import React from "react";
import { ToastContainer } from "react-toastify";
import UpdateBrand from "../../components/ProductManager/Brand/UpdateBrand";

export const UpdateBrandPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <UpdateBrand />
        </div>
      </div>
    </div>
  );
};
